import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom'
import { _resetState } from '../_states/_resetState';
import { _beginformState as _beginformStorage } from '../_states/_beginformState';

function Confirm() {
  // scroll to the top
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

    const navigate = useNavigate();
    const onSubmit = event => {
        navigate('/');
        
        _resetState.setResetState(true);
        _resetState.resetAllStates();
        
        if (_resetState.getResetState()) {
            window.location.reload();
        }
    };
    return (
        <>
            <form onSubmit={onSubmit}>
                <main id="main" className="sectionOne">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-8">
                                <div className="text">
                                    <h1 className="heading-large">Thank you for completing the referral</h1>
                                    <p>We have sent you a confirmation email.</p>
                                    <div>
                                        <h3>Your unique ID number for your referral is {_beginformStorage.getUtrn()}</h3>
                                        <p>Please do not contact us about the referral unless circumstances have changed. How quickly we respond and the type of response will be based on the level of urgency.</p>
                                        <p>In most cases and where required, we will aim to respond or make initial contact within 72 hours of receiving the referral. We may contact you for more information but where appropriate, contact will usually be made directly to the person referred.</p>
                                    </div>
                                    <div className="form-group">
                                        <button className="btn btn-primary btn-arrow" type="submit">Make another referral</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </form>
        </>
    );
};
export default Confirm;;
